<script context="module">
  import ProductAdditions from "./ProductAdditions.svelte";
  import {External, M} from "../../external";

  export function editProductAdditions(product, onDone) {
    External.Tools.showWindow({
      title: M.ADDITIONAL_QUESTIONS,
      width: 550,
      isModal: false,
      withDarkBackground: true,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new ProductAdditions({
              target: popup.getContentArea(),
              props: {
                product: product
              }
            })
          );
        },
        onHide: (popup, ui) => {
          onDone();
        }
      }
    });
  }
</script>

<script>
  import { onMount } from "svelte";

  export let product;

  product.additions = product.additions || {};
  product.additions.fields = product.additions.fields || [];

  let addField = () => {
    product.additions.fields.push({
      name: ""
    });
    product.additions.fields = product.additions.fields;
  };

  let removeField = (idx) => {
    product.additions.fields.splice(idx, 1);
    product.additions.fields = product.additions.fields;
  };

  onMount(() => {});
</script>

<div class="popup-widget-wrapper">
  {#if product.additions.fields.length === 0}
    <h3 class="col20 f-left mb-25 mt-25">{M.NO_FIELDS_YET}</h3>
  {/if}

  {#each product.additions.fields as field, idx}
    <div class="col20 f-left mb-10">
      <h5 class="info">{M.STORE_PRODUCT_ADDITIONAL_FIELD_LABEL}</h5>
      <div class="col20 f-left flex flex-row align-center">
        <input class="flex-1" type="text" bind:value={field.name} />
        <a on:click={() => removeField(idx)} class="flex-none ml-10"><span class="material-icons-outlined">delete</span></a>
      </div>
    </div>
  {/each} 

  <div class="col20 f-left">
    <a class="middle-button blue with-icon f-left" on:click={addField}>{M.ADD_NEW_FIELD}</a>
  </div>
</div>
